$(document).on('click', '.add-service', function () {
    // Remove all existing service rows
    $('.add-service').remove();

    var newRowService = $(`<div class="row-service">` +
        `<label>${$t('site_labels.service')}</label>` +
        `<div class="custom-select service">` +
        `<div class="select-selected select-selected-service">${$t('site_labels.select_service')}</div>` +
        `<div class="select-items select-service select-hide" id="servic"></div>` +
        `<div class="delete-service">-</div>` +
        `<div class="add-service">${$t('site_labels.add_service')}</div>` +
        `</div>` +
        `<label class="detail-label hide-item">${$t('site_labels.details')}</label>` +
        `<div class="custom-select detalis hide-item">` +
        `<div class="select-selected select-selected-details">${$t('site_labels.select_detail')}</div>` +
        `<div class="select-items select-hide select-details" id="detalis"></div>` +
        // `<div class="delete-details">-</div>` +
        `<div class="add-details">${$t('site_labels.add_detail')}</div>` +
        `</div>` +
        `</div>`);

    newRowService.insertAfter('.row-service:last');
});
